import { Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";

import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";

import { ButtonWrapper, CustomButton } from "../../components";
import { images } from "../../constants";
import { clearSMSOtp } from "../redux/action";
import { Container, Row } from "./styles";

const WithdrawalSuccess = props => {
  const { withdrawalResult, history, clearSMSOtp } = props;

  const [withdrawalData, setWithdrawalData] = useState({
    date: "",
    time: "",
    transactionId: "",
    refNo: "",
    amount: "",
    fee: "",
  });

  useEffect(() => {
    localStorage.removeItem("timer");
    clearSMSOtp();
  }, []);

  useEffect(() => {
    if (withdrawalResult) {
      setWithdrawalData(prevState => ({
        ...prevState,
        date: moment(withdrawalResult.date)
          .utcOffset("+0800")
          .format("DD MMM YYYY hh:mm:ss")
          .slice(0, 11),
        time: moment(withdrawalResult.date)
          .utcOffset("+0800")
          .format("DD MMM YYYY hh:mm:ss A")
          .slice(12, 24),
        transactionId: withdrawalResult.transactionId,
        refNo: withdrawalResult.refNo,
        amount: withdrawalResult.amount,
        fee: withdrawalResult.fee,
      }));
    }
  }, [withdrawalResult]);

  return (
    <Container>
      {/* logo */}
      <div style={{ marginTop: "16px", marginLeft: "16px" }}>
        <img src={images.principalLogo} alt="principal-logo" />
      </div>

      {/* Submitted text */}
      <div style={{ margin: "24px 16px" }}>
        <Typography
          color="textPrimary"
          style={{
            fontSize: "20px",
            fontWeight: "700",
          }}
        >
          Cash Out submitted for processing...
        </Typography>
        <Typography
          color="textPrimary"
          style={{
            padding: "16px 0 24px",
            borderBottom: "1px solid #9d9ea4",
          }}
        >
          Your Cash Out request will be processed within 2 business days (T+2)
          for the Save feature and 7 business days (T+7) or up to 15 business
          days (T+15) for foreign feeder funds for the Invest feature.
          <br />
          Final value follows the NAV selling price on your cash-out date.
        </Typography>
      </div>

      {/* Submitted details */}
      <div style={{ margin: "0 16px" }}>
        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Cash Out Amount</Typography>
          <Typography color="textPrimary">
            RM{" "}
            <NumberFormat
              value={withdrawalData.amount}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Bank Transaction Fee</Typography>
          <Typography color="textPrimary">
            RM{" "}
            <NumberFormat
              value={withdrawalData.fee}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Cash Out Via</Typography>
          <Typography color="textPrimary">FPX Online Banking</Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Date</Typography>
          <Typography color="textPrimary">{withdrawalData.date}</Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Time</Typography>
          <Typography color="textPrimary">{withdrawalData.time}</Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Reference No</Typography>
          <Typography color="textPrimary" style={{ textAlign: "right" }}>
            {withdrawalData.refNo}
          </Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginBottom: "8px" }}>
          <Typography color="textPrimary">Transaction ID</Typography>
          <Typography color="textPrimary">
            {withdrawalData.transactionId}
          </Typography>
        </Row>

        <Row style={{ justifyContent: "space-between", marginTop: "16px" }}>
          <Typography
            style={{
              fontSize: "20px",
              fontWeight: "700",
              lineHeight: 1.4,
              color: "#084c95",
            }}
          >
            Total:
          </Typography>
          <Typography
            style={{
              fontSize: "20px",
              fontWeight: "700",
              lineHeight: 1.4,
              color: "#084c95",
            }}
          >
            RM{" "}
            <NumberFormat
              value={withdrawalData.amount - withdrawalData.fee}
              thousandSeparator
              displayType="text"
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </Typography>
        </Row>
      </div>

      <ButtonWrapper
        style={{
          backgroundColor: "#fff",
        }}
      >
        <CustomButton
          text="Done"
          variant="contained"
          color="#fff"
          backgroundColor="#1278cc"
          onClick={() => history.push("/dashboard")}
        />
      </ButtonWrapper>
    </Container>
  );
};

const withConnect = connect(
  state => ({
    withdrawalResult: state.goal.withdrawalResult,
  }),
  { clearSMSOtp }
);

export default compose(
  withRouter,
  withConnect
)(WithdrawalSuccess);
